export const ALERT_DELETE_MESSAGE = "Xóa không thành công!";

export const ALERT_ADD_MESSAGE = "Thêm không thành công!";

export const ALERT_MODIFY_MESSAGE = "Sửa không thành công!";
